import type { NodeKind } from '@netdeck/contracts';

/**
 * Типы узлов, у которых бывает SSH.
 *
 * Список заметно шире, чем у VNC, и это не случайность: рабочий стол
 * по сети отдаёт машина с рабочим столом, а командную строку — почти всё,
 * что стоит в стойке. Коммутатор, роутер, точка доступа и NAS настраиваются
 * ровно так, и именно ради них терминал в платформе и появился.
 *
 * Чего в списке нет: `camera` — у камер свой раздел, а SSH на них если и
 * есть, то заводской и без пользы; `printer`, `ups` и `phone` — их
 * настраивают веб-интерфейсом; `label` — подпись на карте не устройство.
 */
const SSH_CAPABLE_KINDS: ReadonlySet<NodeKind> = new Set<NodeKind>([
  'pc',
  'server',
  'cloud',
  'switch',
  'router',
  'ap',
  'nas',
  'other',
]);

/**
 * Бывает ли на узле такого типа командная строка.
 *
 * Правило одно на всю платформу: панель узла и контекстное меню карты
 * обязаны отвечать одинаково, иначе «Терминал» пропадает в одном месте
 * и остаётся в другом — и человек решает, что платформа сломалась.
 */
export function canHostSsh(kind: NodeKind): boolean {
  return SSH_CAPABLE_KINDS.has(kind);
}

/** Право открывать терминал на узле: ролевое или точечное (§10.3). */
export function canOpenTerminal(
  rolePermissions: ReadonlySet<string>,
  permittedNodeIds: readonly string[],
  nodeId: string,
): boolean {
  return rolePermissions.has('ssh:connect') || permittedNodeIds.includes(nodeId);
}
